import store from '../../init/store.js'
import {getBotDecision} from '../bot-decisions/get-bot-decision.js'
import {submitAction} from '../lifecycle/submit-action.js'
import {decodeCloudQueueActionString} from '../cloud-queue-encode-decode.js'


//These are used both online and offline

//TODO: This function needs to move out of this file. It is utilized Online and Offline
/* Master submit action form for a bot player (only master does this) */
export function masterSelectsActionForBot(combatantSelectingAction = "") {

  const combatants = store.getState().battle.combatants;
  const newSelectingCombatantModel = combatants[combatantSelectingAction];

  //If the next person exists and is a bot, Master needs to submit an aciton for the bot
  if (newSelectingCombatantModel && newSelectingCombatantModel.isBot) {
    //console.log('Master needs to submit an action for the bot');
    const decision = getBotDecision(
      combatantSelectingAction,
      combatants,
      store.getState().battle.teams
    );

    //Submit our new decision. This will create a rollout for bot's action and send up to the server
    //and we'll all receive the end result.
    submitAction(
      decision.actionModel,
      decision.casterModel,
      decision.targetModels
    )
  }
}


/* Master submits stringified action from the cloudQueue. EX: "cloudQueueAction::actionId::casterId:: etc..." */
//TODO: This function needs to move out of this file. It is utilized Online and Offline
export function masterSubmitsQueuedAction(queuedActionDataString = "") {

  const cloudSubmission = decodeCloudQueueActionString(
    queuedActionDataString,
    store.getState().battle.combatants
  );


  submitAction(
    cloudSubmission.actionModel,
    cloudSubmission.casterModel,
    cloudSubmission.targetModels
  )
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/master-submits-actions.js